import withDraft from '@/utils/draftHelper';
import actions from '@/configurations/constants';
import { rolesToSetAsDefault } from './state';

const hideDefaultRole = withDraft((draft) => { draft.roles.defaultSelection = rolesToSetAsDefault(); });

export default {
  [actions.UPDATE_CONFIGURATION_SUCCESS]: hideDefaultRole,
};
